import React, { createContext, useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';

import reducer, {
  PRODUCTS_IN_USE,
  SEARCH_TEXT,
  SEARCHED_PRODUCTS,
  SEARCH_RESULT_PAGES,
  LOADING_PRODUCT_SEARCH,
  IS_LOADING_PRODUCT_IN_USE,
  TABLE_SEARCH_TEXT
} from '../reducer';

export const initialState = {
  productsInUse: [{}],
  searchText: '',
  tableSearchText: '',
  filterValue: null,
  searchedProducts: [{}],
  searchResultPages: 0,
  loadingProductSearch: false,
  isLoadingProductInUse: undefined
};

export const ProductListContext = createContext(initialState);

const ProductListProvider = ({
  children = /** @type {React.ReactNode} */ (null)
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const executeAction = (type, action) => {
    dispatch({
      type,
      payload: action
    });
  };

  const setProductsInUse = payload => executeAction(PRODUCTS_IN_USE, payload);
  const setSearchText = payload => executeAction(SEARCH_TEXT, payload);
  const setSearchedProducts = payload =>
    executeAction(SEARCHED_PRODUCTS, payload);
  const setSearchResultPages = payload =>
    executeAction(SEARCH_RESULT_PAGES, payload);
  const setLoadingProductSearch = payload =>
    executeAction(LOADING_PRODUCT_SEARCH, payload);
  const setIsLoadingProductInUse = payload =>
    executeAction(IS_LOADING_PRODUCT_IN_USE, payload);
  const setTableSearchText = payload =>
    executeAction(TABLE_SEARCH_TEXT, payload);

  const clearAddProduct = () => {
    setSearchText('');
    setSearchedProducts([]);
    setProductsInUse([]);
  };

  const pro = useMemo(
    () => ({
      setProductsInUse,
      productsInUse: state.productsInUse,
      setSearchText,
      searchText: state.searchText,
      setSearchedProducts,
      searchedProducts: state.searchedProducts,
      setSearchResultPages,
      searchResultPages: state.searchResultPages,
      setLoadingProductSearch,
      loadingProductSearch: state.loadingProductSearch,
      setIsLoadingProductInUse,
      isLoadingProductInUse: state.isLoadingProductInUse,
      clearAddProduct,
      setTableSearchText,
      tableSearchText: state.tableSearchText
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      state.productsInUse,
      state.searchText,
      state.searchedProducts,
      state.searchResultPages,
      state.loadingProductSearch,
      state.isLoadingProductInUse,
      state.tableSearchText
    ]
  );

  return (
    <ProductListContext.Provider value={pro}>
      {children}
    </ProductListContext.Provider>
  );
};

ProductListProvider.propTypes = {
  children: PropTypes.node
};

export default ProductListProvider;
